import { config } from '../config'

export const submitFeedback = (requestBody: string, userAccessToken: string): Promise<Response> => {
  const requestHeaders: HeadersInit = new Headers()
  requestHeaders.set('App-Auth-Service-Id', 'here_app')
  requestHeaders.set('App-Auth-Identifier', 'apikey')
  requestHeaders.set('App-Auth-Secret', config.API_KEY)

  requestHeaders.set('Content-Type', 'application/vnd.here.layerObjectList+json; charset=UTF-8')
  requestHeaders.set('Auth-Protocol-Version', '2')

  requestHeaders.set('Authorization', `Bearer ${userAccessToken}`)
  requestHeaders.set('Auth-Service-Id', 'here_sso')

  return fetch(`/feedback`, {
    body: requestBody,
    headers: requestHeaders,
    method: 'POST',
  })
}
